module.exports = __webpack_public_path__ + "static/media/icon.7b3ad622.jpg";